//NT
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";
import pointExchange from "@/navigation/point-exchange";

//NT custom module
import customerManagement from "@/constants/navigation/B8FEBZQ1P8YD/menu/customer-management";

import dashboard from "@/constants/navigation/B8FEBZQ1P8YD/menu/dashboard";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVfcdIFqMSWfHR": // Prod NT BO EP
      switch (decodeToken()?.sub) {
        case "ID_D1v65uU7lgX3": //Prod bagroup@chococrm.com
          return [
            ...dashboard,
            ...customerManagement,
            ...privileges,
            ...inventory,
            ...fulfillment,
            ...banner,
            ...article,
            ...tags,
            ...report,
          ];
      }
    case "PVn0CJL19w6C46": // Prod NT Internal-Marketing team
      switch (decodeToken()?.sub) {
        case "ID_cnX11fWZrHf5": //Prod qtchococrm@gmail.com
          return [
            ...dashboard,
            ...privileges,
            ...banner,
            ...article,
            ...inventory,
            ...report,
          ];
      }
    case "PV80F9FFvjJe9D": // Prod NT Internal-AE
      switch (decodeToken()?.sub) {
        case "ID_wkvbJKEDDz8q": //Prod jutrarut.sa@chococrm.com
          return [
            ...dashboard,
            ...customerManagement,
            ...privileges,
            ...inventory,
            ...fulfillment,
            ...banner,
            ...article,
            ...tags,
            ...report,
          ];
      }
    case "PVVhUhFVRjIOrB": // Prod NT Internal-Call center
      switch (decodeToken()?.sub) {
        case "ID_HISxrNdv83z2": //Prod callcenter@chococrm.com
          return [...customerManagement, ...fulfillment];
      }
    case "PVeOMEzGKmvjWs": // Prod NT Internal-Project-Co
      switch (decodeToken()?.sub) {
        case "ID_AAd0oQRYCSjZ": //Prod project.co@chococrm.com
        case "ID_QomMHNaenMci": //Prod nattawadee.in@chococrm.com
          return [
            ...privileges,
            ...inventory,
            ...fulfillment,
            ...banner,
            ...article,
            ...tags,
            ...report,
          ];
      }
    case "PVeVWbUWHiljYx": // Prod NT External-Superadmin
      switch (decodeToken()?.sub) {
        case "ID_iC6A9v07nopZ": //Prod khanittha.r@ntplc.co.th
          return [
            ...dashboard,
            ...customerManagement,
            ...privileges,
            ...inventory,
            ...fulfillment,
            ...banner,
            ...article,
            ...tags,
            ...report,
          ];
      }
    case "PV2Up80cygWG0p": // Prod NT External-user
      switch (decodeToken()?.sub) {
        case "ID_T5vv7tJfDCKe": //Prod sorrapon.k@ntplc.co.th
        case "ID_o5jrdzKifDrK": //Prod bancha.n@ntplc.co.th
        case "ID_ZMtUwGJRKwgK": //Prod sujittra.s@ntplc.co.th
        case "ID_u4Jiais1awch": //Prod subanthita.s@ntplc.co.th
        case "ID_Apftc40qZ1os": //Prod nichapat.k@ntplc.co.th
        case "ID_4kfH6Yqfgw4i": //Prod wethon.w@ntplc.co.th
        case "ID_4osWLmi6oiVC": //Prod sirikunya.s@ntplc.co.th
        case "ID_FLNLeRlGFJgU": //Prod sopaporn.h@ntplc.co.th
        case "ID_rVsqi3B89xh5": //Prod paweena.e@ntplc.co.th
        case "ID_sI8vG61B4LXC": //Prod suwimol.p@ntplc.co.th
        case "ID_0A56PiHJ4oCW": //Prod ninlawan.m@ntplc.co.th
        case "ID_VDEXBax5aeBH": //Prod ponpan.k@ntplc.co.th
        case "ID_kohq7uy5uunq": //Prod pak.k@ntplc.co.th
        case "ID_k00JHgn1kIDL": //Prod sathaporn.h@ntplc.co.th
        case "ID_vUJBiVc1dDjL": //Prod athiphat.p@ntplc.co.th
        case "ID_DfRsr3QNivmQ": //Prod kodchaporn.j@ntplc.co.th
        case "ID_4Szo6YnkW2Uc": //Prod piyarat.wo@ntplc.co.th
        case "ID_1lRKAU3pkyav": //Prod phimdaw.p@ntplc.co.th
        case "ID_HXbGRAw4WFtP": //Prod suthathip.y@ntplc.co.th
        case "ID_nYO7EUFPdP6Q": //Prod sutisa.c@ntplc.co.th
        case "ID_Up50uEzJpxb8": //Prod sutapat.p@ntplc.co.th
        case "ID_6EtYyxQGyTYa": //Prod thanya.s@ntplc.co.th
        case "ID_2g9CXSy9eRPT": //Prod parichart.c@ntplc.co.th
        case "ID_xfRbD1qfnRe6": //Prod callcenter@chococrm.com
          return [...customerManagement];
      }
    default:
      return [
        ...dashboard,
        ...customerManagement,
        ...privileges,
        ...inventory,
        ...fulfillment,
        ...banner,
        ...article,
        ...tags,
        ...report,
      ];
  }
};

export default renderNavByPermission();
